module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-night3.3f21e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-night3.png
// module id = +3eo
// module chunks = 0